import React from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { Trans } from '@lingui/react';
import { Container } from '@components/layout/Grid';
import RightIcon from '@assets/ShevronRightIcon';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 20px;

  @media (min-width: ${({ theme }) => theme.viewports.laptop}px) {
    flex-direction: row;
  }
`;

const Item = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  :not(:last-of-type) {
    margin-bottom: 50px;
  }

  @media (min-width: ${({ theme }) => theme.viewports.laptop}px) {
    :not(:last-of-type) {
      margin-bottom: 0;
    }

    :not(:last-of-type) {
      border-right: 1px solid lightgrey;
      padding-right: 25px;
      margin-right: 25px;
    }
  }
`;

const Title = styled.p`
  font-size: 24px;
  margin: 0 0 20px;
`;

const Desc = styled.p`
  flex: 1;
  font-size: 16px;
  margin: 0 0 30px;
`;

const Link = styled.a`
  display: flex;
  align-items: center;
  color: #ea6ea3;
  font-weight: 500;
  text-transform: uppercase;
  text-decoration: none;

  svg {
    height: 20px;
    margin-left: 10px;
  }
`;

const FourthSection = () => {
  const router = useRouter();
  const { lang } = router.query;

  const items = [
    {
      title: <Trans id="landingpage.section4.item1.title" />,
      desc: <Trans id="landingpage.section4.item1.desc" />,
      link: `/${lang}/foretag/arbetsgivare`,
    },

    {
      title: <Trans id="landingpage.section4.item2.title" />,
      desc: <Trans id="landingpage.section4.item2.desc" />,
      link: `/${lang}/blog/wellnet-actiway-benify-friskvardsbidrag`,
    },

    {
      title: <Trans id="landingpage.section4.item3.title" />,
      desc: <Trans id="landingpage.section4.item3.desc" />,
      link: `/${lang}/non-profit`,
    },
  ];

  return (
    <Container flexDirection={'column'} px={[25, 20, 20]} py={40}>
      <Content>
        {items.map((item, i) => {
          return (
            <Item key={i}>
              <Title>{item.title}</Title>
              <Desc>{item.desc}</Desc>
              <Link href={item.link}>
                <Trans id="landingpage.section4.readmore" />
                <RightIcon />
              </Link>
            </Item>
          );
        })}
      </Content>
    </Container>
  );
};

export default FourthSection;
